import {
  authGroupsKeys,
  RequestTypes,
} from '@core/react-query/features/authGroups'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { AuthGroup, IAuthGroup } from '@core/entities/Groups/AuthGroups'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const authGroupTransform = (authGroup: IAuthGroup) => {
  return AuthGroup.new(authGroup)
}

export const useGetAuthGroup = (
  payload: RequestTypes['getAuthGroup'],
  options?: UseQueryOptions<IAuthGroup, RequestErrorType, AuthGroup>,
) => {
  return useQuery({
    ...authGroupsKeys.byId(payload),
    select: authGroupTransform,
    enabled: !!payload.groupId,
    retry: 3,
    ...options,
  })
}
